import { useState } from 'react'

import { makeUrlUserActivate } from '@/hooks/connectionData.tsx'
import { customPost } from '@/utils/customFetch.ts'

const useUserActivate = () => {
  const [errorUserActivate, setErrorUserActivate] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const userActivate = async (_id: string, activate: boolean, by: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlUserActivate()
      const res = await customPost<{ message: string }>(apiUrl, { _id: _id, activate: activate, by })
      setErrorUserActivate(null)

      return res.message
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorUserActivate(err)
      } else {
        setErrorUserActivate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorUserActivate, loading, userActivate }
}
export default useUserActivate
